import { useNavigate } from "react-router-dom";
import { ArrowLongLeftIcon, ArrowLongRightIcon } from "@heroicons/react/24/solid";
import { scoreReportDraftAndPromptLink } from "../../../app/links";
import TextWithTip from "../../../components/TextWithTip";
import { WritingAction } from "../../writing/writingApiSlice";
import { WriterEssayForPromptViewModel } from "../scoreReportApiSlice";

interface NavigationProps {
	lastDraftId: number;
	promptId: number;
	allWriters?: WriterEssayForPromptViewModel[];
	showEssayCount: boolean;
	clearSharedAlert: () => void;
	className?: string;
}

export default function NavigateToOtherEssays(props: NavigationProps) {
	const navigate = useNavigate();

	const currentIndex = props.allWriters?.findIndex((w) => w.actionId === props.lastDraftId) ?? 0;

	const goTo = (index: number) => {
		if (!props.allWriters) return;
		const writer = props.allWriters[index];
		props.clearSharedAlert();
		navigate(scoreReportDraftAndPromptLink(props.promptId, writer.actionId), {
			state: {
				section: writer.action === WritingAction.Organize ? "OrganizerSection" : null,
			},
		});
	};

	return (
		props.allWriters && (
			<section className={`grid grid-cols-3 h-8 print:hidden ${props.className}`}>
				<div className="col-start-1">
					{currentIndex > 0 && (
						<button onClick={() => goTo(currentIndex - 1)} className="link text-left">
							<span className="flex items-center gap-3">
								<ArrowLongLeftIcon className="size-6 shrink-0" />
								<div className="w-72">
									<TextWithTip
										uniqueName="previousWriter"
										text={props.allWriters[currentIndex - 1].writerName}
									/>
								</div>
							</span>
						</button>
					)}
				</div>

				{props.showEssayCount && (
					<div className="col-start-2 flex justify-center items-center">
						<span className="font-medium">
							Essay {currentIndex + 1} of {props.allWriters.length}
						</span>
					</div>
				)}

				<div className="col-start-3 flex justify-end">
					{currentIndex < props.allWriters.length - 1 && currentIndex !== -1 && (
						<button onClick={() => goTo(currentIndex + 1)} className="link text-right">
							<span className="flex items-center gap-3">
								<div className="w-72">
									<TextWithTip
										uniqueName="nextWriter"
										text={props.allWriters[currentIndex + 1].writerName}
									/>
								</div>
								<ArrowLongRightIcon className="size-6 shrink-0" />
							</span>
						</button>
					)}
				</div>
			</section>
		)
	);
}
